import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import axios from 'axios';
import PropagateLoader from 'react-spinners/PropagateLoader';
import stepsIcon from 'assets/images/steps.png';
import fullScreenIcon from 'assets/images/arrow-button.png';
import './style.scss';
import easyIcon from 'assets/images/easy.png';
import superfastIcon from 'assets/images/super-fast.png';
import { newCheckInAction, newNextAction } from 'actions/navigation';
import Header from 'components/Header';
import PdfViewer from './PdfViewer';
import Button from '../../components/Button';

const EsignLoanDocs = (props) => {
  const { checkinData, location, navigate, params, searchParams } = props;
  const [isChecked, setIsChecked] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const workflowType = get(params, 'workflowType') || 'text2apply';
  const key = searchParams.get('key');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const base64ToArrayBuffer = (data) => {
    if (data) {
      const binaryString = window.atob(data);
      const bytes = new Uint8Array(binaryString.length);
      const arrayBuffer = bytes.map((item, idx) => binaryString.charCodeAt(idx));
      return arrayBuffer;
    }
  };

  const convertedPdfUrl = (pdfData) => {
    const type = 'PDF';
    const arrayBuffer = base64ToArrayBuffer(get(pdfData, 'data.data.loanDocument'));
    const file = new Blob([arrayBuffer], { type: `application/${type}` });
    const data = window.URL.createObjectURL(file);
    setPdfUrl(data);
    setTimeout(() => {
      setPageLoad(false);
    }, 3000);
  };

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    } else {
      convertedPdfUrl(checkinData);
    }
  }, []);

  const handleEsign = async () => {
    setLoading(true);
    let ipAddress;
    try {
      const ipAddressResponse = await axios.get('https://api.ipify.org?format=json');
      ipAddress = ipAddressResponse.data.ip;
    } catch (e) {
      ipAddress = 'static ip';
    }
    props.newNextAction({
      workflowType,
      key,
      data: {
        id: get(checkinData, 'attributes.entityId'),
        error: null,
        IpAddress: ipAddress,
      },
      success: (res) => {
        navigate(get(res, 'data.url'));
        setLoading(false);
      },
    });
  };

  return (
    <div className="esign-wrapper">
      <Header isShownProgress completePerecent={5} />
      <div className="esign-container">
        <div className="application-header">
          <b>Application ID:</b>
          {' '}
          {get(checkinData, 'attributes.entityId')}
        </div>
        {pageLoad
          ? (
            <div style={{ height: 350, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <PropagateLoader size={20} loading color="#3989E3" />
            </div>
          )
          : (
            <>
              <div className="page-head">
                <h1>You&apos;re almost there! Just click and go!</h1>
                <h4>Please electronically sign your documents</h4>
              </div>
              <div className="esign-agreement-text">
                <p>
                  By clicking the
                  <strong> ACKNOWLEDGE </strong>
                  button below and clicking
                  <strong> ESIGN LOAN DOCUMENTS</strong>
                  , you acknowledge that you have read and agree to the
                  {' '}
                  <a href={pdfUrl} target="_blank" rel="noopener noreferrer"><strong>Loan Documents</strong></a>
                  {' '}
                  and are electronically signing every document contained therein that requires your signature.
                </p>
              </div>
              <div className="esign-actions">
                <button
                  type="button"
                  className={`btn-acknowledge ${isChecked ? 'checked' : ''}`}
                  onClick={handleCheckboxChange}
                >
                  <span className="acknowledge-circle">
                    {isChecked && (
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </span>
                  ACKNOWLEDGE
                </button>
                <Button
                  className="btn btn-primary arrow"
                  onClick={handleEsign}
                  title={loading ? 'Loading....' : 'ESIGN LOAN DOCUMENTS'}
                  isDisabled={!isChecked || loading}
                />
              </div>
            </>
          )}
        <div className="loan-agreement-wrapper">
          {!pageLoad
            ? (
              <div className="features">
                <div>
                  <span><img src={easyIcon} alt="EasyIcon" /></span>
                  <p>
                    We&apos;ve Made
                    <br />
                    {' '}
                    This Easy
                  </p>
                </div>
                <div>
                  <span><img src={superfastIcon} alt="SuperfastIcon" /></span>
                  <p>
                    Super Fast
                    <br />
                    {' '}
                    E-Sign
                  </p>
                </div>
                <div>
                  <span><img src={stepsIcon} alt="StepsIcon" /></span>
                  <p>
                    Here To Help
                    <br />
                    {' '}
                    At Each Step
                  </p>
                </div>
              </div>
            )
            : <div style={{ height: 165 }} />}
          <div className="agreement">
            <div>
              <div className="agreement-header">
                <p><u>Loan Agreement</u></p>
                <button type="button" onClick={() => window.open(pdfUrl)}>
                  <img src={fullScreenIcon} alt="Fullscreen" style={{ width: 20 }} />
                </button>
              </div>
              <div className="pdf-wrapper">
                {pdfUrl ? <PdfViewer file={pdfUrl} /> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EsignLoanDocs.propTypes = {
  checkinData: PropTypes.object.isRequired,
  newNextAction: PropTypes.func.isRequired,
  location: PropTypes.object,
  navigate: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

EsignLoanDocs.defaultProps = {
  location: {},
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsignLoanDocs);
